/* Presentation only: RingLab still owns values, availability, exact variant resolution and progression. */
(() => {
  const instances = new WeakMap();
  const selector = 'corsaille-ring-lab[data-concept="hybrid"]';
  const setToken = (token, value) => {
    const metal = window.CorsailleMetalMedia?.normalizeMetal(value);
    const alloy = metal?.material === 'platinum' ? 'platinum' : metal?.family || 'unknown';
    const purity = metal?.purity || '';
    const changed = token.dataset.alloy !== alloy || token.dataset.purity !== purity;
    if (token.dataset.alloy !== alloy) token.dataset.alloy = alloy;
    if (token.dataset.purity !== purity) token.dataset.purity = purity;
    return changed;
  };
  const attach = root => {
    if (!root.ready || instances.has(root) || ['epure-oval', 'epure-blue'].includes(root.dataset.handle)) return;
    const option = root.options?.find(item => item.kind === 'metal');
    if (!option) return;
    const step = root.querySelector(`[data-option-step="${option.index}"]`);
    const current = step?.querySelector('[data-option-current]');
    const number = step?.querySelector('.cl-step-number');
    if (!step || !current || !number) return;
    step.classList.add('cl-metal-step');
    step.querySelectorAll('input[type="radio"][data-option-index]').forEach((input, index) => {
      const choice = input.closest('.cl-choice'), label = input.nextElementSibling;
      const token = label?.querySelector('.cl-swatch');
      if (!choice || !token) return;
      choice.classList.add('cl-metal-choice');
      choice.style.setProperty('--cl-metal-order', Math.min(index, 5));
      token.classList.add('cl-metal-token');
      setToken(token, input.value);
    });
    const summaryToken = document.createElement('span');
    summaryToken.className = 'cl-metal-token';
    summaryToken.setAttribute('aria-hidden', 'true');
    number.append(summaryToken);
    let initialized = false, pending = false, animation = null, destroyed = false;
    const refresh = () => {
      pending = false;
      if (destroyed) return;
      const value = root.selected?.[option.index];
      if (typeof value !== 'string') return;
      const changed = setToken(summaryToken, value);
      if (initialized && changed && summaryToken.animate) {
        animation?.cancel();
        animation = summaryToken.animate([{ opacity: .55, transform: 'scale(.92)' }, { opacity: 1, transform: 'scale(1)' }], { duration: 170, easing: 'cubic-bezier(.22,1,.36,1)' });
      }
      initialized = true;
    };
    const schedule = () => { if (!pending && !destroyed) { pending = true; queueMicrotask(refresh); } };
    // Observe only RingLab's text node: our decorative token is outside it, so no observer loop.
    const observer = new MutationObserver(schedule);
    observer.observe(current, { childList: true, subtree: true, characterData: true });
    root.addEventListener('change', schedule);
    const dispose = () => {
      destroyed = true; observer.disconnect(); animation?.cancel();
      root.removeEventListener('change', schedule); root.removeEventListener('hybrid:dispose', dispose);
      summaryToken.remove(); instances.delete(root);
    };
    instances.set(root, dispose);
    root.addEventListener('hybrid:dispose', dispose);
    refresh();
  };
  const inSection = (section, action) => {
    if (section.matches?.(selector)) action(section);
    section.querySelectorAll?.(selector).forEach(action);
  };
  customElements.whenDefined('corsaille-ring-lab').then(() => inSection(document, attach));
  document.addEventListener('shopify:section:load', event => inSection(event.target, attach));
  document.addEventListener('shopify:section:unload', event => inSection(event.target, root => instances.get(root)?.()));
})();
